export const GET_COUNTRY_SPECIALTY_LIST = `query($filter: AbbvieProGroupSpecialtyFilter){
	allAbbvieProGroupSpecialties(filter:$filter){
		nodes{
			id
			country
			name:groupSpecialtyName
		}
	}
}`;

export const CREATE_GROUP_SPECIALTY = `mutation($abbvieProGroupSpecialty: AbbvieProGroupSpecialtyInput!){
	createAbbvieProGroupSpecialty(input:{
		abbvieProGroupSpecialty:$abbvieProGroupSpecialty
	})

	{
		abbvieProGroupSpecialty{
			id
		}
	}
}`;

export const CREATE_SPECIALTY = `mutation($abbvieProSpecialtyMap: AbbvieProSpecialtyMapInput!){
	createAbbvieProSpecialtyMap(input:{
		abbvieProSpecialtyMap:$abbvieProSpecialtyMap
	})
	{
		abbvieProSpecialtyMap{
			groupId
		}
	}
}`;

export const UPDATE_SPECIALTY = `mutation($id:UUID!, $abbvieProSpecialtyMap: AbbvieProSpecialtyMapPatch!){
	updateAbbvieProSpecialtyMapById(input:{
		id:$id,
		abbvieProSpecialtyMapPatch: $abbvieProSpecialtyMap
	})
	{
		abbvieProSpecialtyMap{
			id
			specialtyId
            specialtyName
            groupId
			abbvieProGroupSpecialtyByGroupId {
                groupSpecialtyName
			}
		}
	}
}`;

export const DELETE_SPECIALTY = `mutation($id:UUID!){
	deleteAbbvieProSpecialtyMapById(input:{
		id:$id
	})
	{
		abbvieProSpecialtyMap{
			groupId
		}
	}
}`;

export const GET_ALL_SPECIALTY = `query( $filter: AbbvieProSpecialtyMapFilter, $first:Int,$last:Int,$after:Cursor,$before:Cursor){
    allAbbvieProSpecialtyMaps(orderBy:CREATED_AT_DESC, first:$first, last:$last, after:$after, before:$before, filter:$filter){
      nodes{
        id
        specialtyId
        specialtyName
        groupId
        abbvieProGroupSpecialtyByGroupId{
		    groupSpecialtyName
            country
        }
        createdAt
      }
      totalCount
      pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
}`;
